import _ from "lodash";

export default (state: any[] = [], action: any) => {
	switch (action.type) {
		case "GET_CONDITION_SUCCESS":
		case "PUT_CONDITION_FILL_SUCCESS":
		case "POST_CONDITION_GENERATE_PDF_SUCCESS":
		case "POST_CONDITION_CONFIGURE_SIGNERS_SUCCESS":
		case "POST_CONDITION_ATTACH_SIGNED_DOC_SUCCESS":
		case "POST_CONDITION_UNDO_GENERATION_SUCCESS":
			return _.unionBy([action.resource], state, "id");
		case "GET_CONDITIONS_SUCCESS":
			return _.unionBy(action.resource as any[], state, "id");
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
